<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useSlots, useAttrs } from 'vue';
const attrs = useAttrs();

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    value: {
        type: [Object, String, Number, Array, Boolean, null],
        default: null
    },
    items: {
        type: Array,
        default: () => []
    },
    label: {
        type: String,
        default: ''
    },
    itemValue: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits(['change']);

/*==================================================================*/
/*================== HANDLERS ======================================*/
/*==================================================================*/

const onChange = (event) => {

    if(!event){
        event = "";
    }

    emits('change', event);

}

/*==================================================================*/
/*================== SLOTS =========================================*/
/*==================================================================*/

const slots = useSlots();

</script>

<template>

    <v-select
        class="c-select"
        :value="props.value"
        :items="props.items"
        :label="props.label"
        :item-value="props.itemValue"
        :disabled="props.disabled"
        outlined
        clearable
        hide-details
        v-bind="attrs"
        @change="onChange"
    >

        <template v-if="slots.item" #item="slotProps">
            <slot name="item" v-bind="slotProps"></slot>
        </template>
        <template v-if="slots.selection" #selection="slotProps">
            <slot name="selection" v-bind="slotProps"></slot>
        </template>

    </v-select>
</template>

<style scoped>

.c-select{
    padding: 2px;
}

</style>
